import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';

export const WindowTypeEntrySchema = z.object({
  material: z.string().optional(),
  numberOfPanes: z.coerce.number().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});

export const DoorTypeEntrySchema = z.object({
  materials: z.string().optional(),
  types: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});

export const WallTypeEntrySchema = z.object({
  claddingTypes: z.string().optional(),
  structuralFraming: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});

export const RoofingTypeEntrySchema = z.object({
  types: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});

export const EnvelopeSchema = z.object({
  coverPhoto: z.array(AttachmentSchema).max(1).optional(),
  windowTypes: z.array(WindowTypeEntrySchema).optional(),
  doorTypes: z.array(DoorTypeEntrySchema).optional(),
  wallTypes: z.array(WallTypeEntrySchema).optional(),
  roofingTypes: z.array(RoofingTypeEntrySchema).optional(),
});

export type WindowTypeEntry = z.infer<typeof WindowTypeEntrySchema>;
export type DoorTypeEntry = z.infer<typeof DoorTypeEntrySchema>;
export type WallTypeEntry = z.infer<typeof WallTypeEntrySchema>;
export type RoofingTypeEntry = z.infer<typeof RoofingTypeEntrySchema>;
export type Envelope = z.infer<typeof EnvelopeSchema>;
